export default __webpack_public_path__ + "static/media/vrepo_.10fee09d.svg";